import { Suspense, use } from "react";
import {
  DocsBody,
  DocsDescription,
  DocsPage,
  DocsTitle,
  MarkdownCopyButton,
} from "fumadocs-ui/layouts/docs/page";
import { docs } from "../lib/collections";
import type { ContentPageData } from "../lib/server";
import { BrandFamilyLine } from "@/components/brand-family";
import { JsonLd } from "@/components/seo/json-ld";
import { getMDXComponents } from "./mdx";

function Body({ data }: { data: ContentPageData }) {
  const page = docs.getPage(data.path);
  if (!page) throw new Error(`Unknown content page: ${data.path}`);
  const { toc } = use(page.load());
  const MDX = page.body;
  return (
    <DocsPage
      toc={toc}
      full={data.url === "/docs/api/reference"}
      // The family line every page of the three sites carries (brand-family.tsx), after the
      // previous and next links, in the server HTML so crawlers that run no scripts read it.
      footer={{
        children: (
          <div className="mt-8 border-t border-hb-card pt-6 text-sm">
            <BrandFamilyLine
              className="text-hb-muted"
              linkClassName="underline underline-offset-2"
            />
          </div>
        ),
      }}
    >
      {data.schemas.length > 0 && <JsonLd data={data.schemas.flat()} />}
      <DocsTitle>{data.title}</DocsTitle>
      <DocsDescription>{data.description}</DocsDescription>
      <div className="mb-6 border-b border-hb-card pb-6">
        <MarkdownCopyButton markdownUrl={data.markdownUrl} />
      </div>
      <DocsBody>
        <MDX components={getMDXComponents()} />
      </DocsBody>
    </DocsPage>
  );
}

export function ContentPage({ data }: { data: ContentPageData }) {
  return (
    <Suspense fallback={<div className="p-8 text-hb-muted">Loading page…</div>}>
      <Body data={data} />
    </Suspense>
  );
}
